export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: "I've been teaching active-aging classes for eleven years, so it wasn't knowledge I was missing — it was time. Sunday nights used to disappear into building the week's classes. Now I open the Ready-To-Teach Class Library, pick what fits the group, adjust two exercises, and I'm done in fifteen minutes. My participants noticed the sessions got more consistent before I ever told them anything changed.",
    author: 'Deborah Hayes',
    role: 'Senior Fitness Instructor, 54',
    location: 'Sarasota, FL',
  },
  {
    text: 'Being able to actually see the movement is what changed how I coach. I run one class with a 62-year-old marathon walker and an 84-year-old using a walker, and I used to improvise the middle ground badly. Having the visual progressions and regressions for the same exercise means nobody sits out and nobody is bored.',
    author: 'Michael Trent',
    role: 'Personal Trainer & Active-Aging Coach, 47',
    location: 'Fort Collins, CO',
  },
  {
    text: "I coordinate programming for four community centers, which means I'm handing plans to instructors who all have different experience levels. The 12-Month Programming & Progression System gave us one shared structure to work from. Our attendance retention is up noticeably this season and my instructors stopped calling me at 8pm asking what to teach.",
    author: 'Yolanda Reese',
    role: 'Community Fitness Coordinator, 58',
    location: 'Columbus, OH',
  },
  {
    text: 'I moved into senior fitness after fifteen years of general group training, and I underestimated how different the planning is. This system was the bridge. The circuits and training stations gave my classes structure I could see at a glance, and the Chair Fitness bonus covered the participants I was least confident with. I stopped second-guessing myself in front of the room.',
    author: 'Priya Raghunathan',
    role: 'Group Fitness Instructor, 41',
    location: 'Mississauga, ON',
  },
  {
    text: "At 63 I'm close to the age of the people I train, and I've bought a lot of programs that were clearly written by someone who's never coached an 80-year-old. This one wasn't. The Movement Library is genuinely organized by ability, the printables are usable as-is, and the whole thing respects that I already know how to teach.",
    author: 'Frank Delgado',
    role: 'Assisted Living Wellness Lead, 63',
    location: 'Chandler, AZ',
  },
]
